<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/sFom92/tc-custom/9781936535347.jpg?1730238099337" alt="This image is the cover for the book Captain, Dirigent Mercenary Corps"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Captain, Dirigent Mercenary Corps
      </h1>
      <p class="bookDescription body article font2">
        <b>A disgraced soldier seeks redemption in a pulse-pounding military science fiction thriller from the national bestselling author of the Special Ops Squad.</b><br/><br/>The year is 2804 AD. Humanity has colonized the universe. But the authority of the Confederation of Human Worlds is spread thin. Where the Army of planet Earth cannot reach, mercenaries must keep the peace—and the Dirigent Mercenary Corps are the best of the best.<br/><br/>Serving with the Dirigent Mercenary Corps wasn’t Lt. Lon Nolan’s first choice—it was his only choice. After he was expelled from the North American Military Academy, there was nowhere else to go. He’s finally made a place for himself with the DMC when a girl has to go and throw a wrench in his plans. Sara Pines is beautiful and brilliant, and he’s sure she’s the one.<br/><br/>Unfortunately, Lon’s shipped out to quell a civil war on a distant planet before he has a chance to marry the woman he loves. And now that he’s arrived on Aldrin, it’s becoming increasingly clear that he might never make it home . . .<br/><br/>“Rick Shelley was a soldier at heart, and his books were written from the heart. They carry the real feel of the sweat, blood, and camaraderie of those on the front lines.” —Jack Campbell, <i>New York Times</i>–bestselling author
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Rick Shelley
      </h2>
      
      <p class="authorDescription body article">Rick Shelley (January 1, 1947 - January 27, 2001) was a military science fiction author. In addition to a plethora of short fiction, he also wrote the Dirigent Mercenary Corps, Spec Ops Squad, Federation War, 13 Spaceborn, Seven Towers, and Varayan Memoir series.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Jabberwocky Literary Agency
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1f35c963